import { FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import {
  ActionLabel,
  getPlaceholder,
  getPlaceholderForConversionReportType,
  getPlaceholderForCustomReportType,
  getPlaceholderForPFTrans,
  getPlaceholderForPFFinal,
  getStatus,
  getStatusForConversionReportType,
  getStatusForCustomReportType,
  getStatusForPFTrans,
  getStatusForPFFinal,
  statusKeys
} from '../../../data';
import { useMemo, useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { SubmissionMenuItem, SubmissionMenuWrapper } from './style';
import { useSubmitStatus } from '../../../../../../services/automation.service';
import toast from 'react-hot-toast';
import { REPORT_TYPES } from '../../../../../../consts/reportTypes';

export const SubmissionColumn = ({ period, refetch, reportType }) => {
  const status = useMemo(() => {
    if (period.filing_type === 'PF_FINAL') return getStatusForPFFinal(period);
    if (period.filing_type === 'PF_TRANS') return getStatusForPFTrans(period);
    if (reportType === REPORT_TYPES.CONVERSION) return getStatusForConversionReportType(period);
    else if (reportType === REPORT_TYPES.CUSTOM) return getStatusForCustomReportType(period);

    return getStatus(period);
  }, [reportType, period]);

  const placeholder = useMemo(() => {
    if (period.filing_type === 'PF_FINAL') return getPlaceholderForPFFinal(period);
    if (period.filing_type === 'PF_TRANS') return getPlaceholderForPFTrans(period);
    if (reportType === REPORT_TYPES.CONVERSION)
      return getPlaceholderForConversionReportType(period);
    else if (reportType === REPORT_TYPES.CUSTOM) return getPlaceholderForCustomReportType(period);

    return getPlaceholder(period);
  }, [reportType, period]);

  const [isOpenPopover, setIsOpenPopover] = useState(false);

  const submitStatus = useSubmitStatus();

  const onSubmit = () => {
    submitStatus.mutate(
      {
        periodId: period.id,
        data: {
          status: 'Completed'
        }
      },
      {
        onSuccess: () => {
          refetch();
        },
        onError: () => {
          toast.error('Error on submitting period');
        },
        onSettled: () => {
          setIsOpenPopover(false);
        }
      }
    );
  };

  if (period.submit_progress_status === 'Completed')
    return <ActionLabel label="Submitted" color="#40C057" />;

  if (status !== statusKeys.SUBMISSION && status !== statusKeys.END)
    return <ActionLabel placeholder={placeholder} />;

  if (submitStatus.isLoading) return <ActionLabel placeholder="Submitting..." />;

  return (
    <>
      <Popover
        isOpen={isOpenPopover}
        positions={['bottom', 'left']}
        onClickOutside={() => setIsOpenPopover(false)}
        content={
          <SubmissionMenuWrapper>
            <SubmissionMenuItem onClick={onSubmit} style={{ color: '#40C057' }}>
              Submitted
            </SubmissionMenuItem>
            <SubmissionMenuItem
              onClick={() => setIsOpenPopover(false)}
              style={{ color: '#FD7E14' }}
            >
              Not submitted
            </SubmissionMenuItem>
          </SubmissionMenuWrapper>
        }
      >
        <div>
          <ActionLabel
            label="Not submitted"
            onClick={() => {
              setTimeout(() => {
                setIsOpenPopover(prev => !prev);
              }, 100);
            }}
            textDecoration="none"
            rightIcon={isOpenPopover ? <FaChevronUp /> : <FaChevronDown />}
            color="#FD7E14"
          />
        </div>
      </Popover>
    </>
  );
};
